<template>
	<div class="modalContainer" id="abstractFormModal">
		<div class="modal col-11 col-md-8 col-lg-6 py-3">
			<span class="close modalClose" @click="closeModal">
				<i class="fas fa-times"></i>
			</span>
			<div class="text-center">
				<h2>Submit Abstract</h2>
			</div>
			<div v-if="!formSent">
				<form
					@submit="handleForm($event)"
					id="quotationForm"
					enctype="multipart/form-data"
				>
					<div class="inputGroup halfGroup mb-5">
						<label for="">Organization Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.organization"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Position/Title</label>
						<input
							type="text"
							class="text-input"
							v-model="user.title"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">First Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.first_name"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Last Name</label>
						<input
							type="text"
							class="text-input"
							v-model="user.last_name"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Email Address</label>
						<input
							type="text"
							class="text-input"
							v-model="user.email"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Phone number</label>
						<input
							type="text"
							class="text-input"
							v-model="user.phone_number"
							required
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Town/City:</label>
						<input
							type="text"
							class="text-input"
							v-model="user.town"
						/>
					</div>

					<div class="inputGroup halfGroup mb-5">
						<label for="">Country</label>
						<input
							type="text"
							class="text-input"
							v-model="this.user.country"
							required
						/>
					</div>

					<div class="inputGroup mb-5">
						<label for="">Abstract File</label>
						<input
							type="file"
							class="file-input"
							id="abstract_file"
							accept=".pdf,.doc,docx"
							@change="handleFile"
							required
						/>
					</div>

					<div class="inputGroup">
						<h4>Fees:</h4>
						<div
							class="checkboxGroup"
							v-for="fee in fees"
							:key="fee.id"
						>
							<input
								type="radio"
								name="presenter_fee"
								v-bind:id="'fee-' + fee.id"
								v-bind:value="fee.id"
								@change="handleFee"
								required
							/>
							<label :for="'fee-' + fee.id">{{
								fee.name + ': ' + fee.amount + ' ' + fee.currency
							}}</label>
						</div>
					</div>

					<div class="inputGroup text-center">
						<button class="secondary" id="abstractsSubmitBtn">
							Send &nbsp;
							<i class="fas fa-paper-plane"></i>
						</button>
					</div>
				</form>
			</div>
			<div v-if="formSent" class="text-center">
				<h3 class="text-center">Your Spot has been Reserved!</h3>
				<h4 class="text-center" style="color: white">Check your email for more details</h4>
				<span>
					<i class="fas fa-check-double fa-8x"></i>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import Api from "../../../services";
import posthog from "posthog-js";
import { fileUrl } from "../../../helpers/imgUrl";

export default {
	props: ["conference"],
	created() {
		this.getFees();
	},
	data() {
		return {
			user: {
				organization: "",
				title: "",
				first_name: "",
				last_name: "",
				email: "",
				phone_number: "",
				town: "",
				country: "",
				conference: null,
				is_presenter: true,
			},
			file: {},
			fees: [],
			selectedFeeId: null,
			formSent: false,
		};
	},
	methods: {
		getFees() {
			Api.conferenceFees
				.get("?fee_type=presenter&_sort=id:asc")
				.then((res) => (this.fees = res.data))
				.catch((e) => console.log(e));
		},
		closeModal() {
			var modal = document.getElementById("abstractFormModal");
			modal.style.display = "None";
		},
		validateForm() {
			if (
				this.user.first_name &&
				this.user.last_name &&
				this.user.email
			) {
				return true;
			} else {
				return false;
			}
		},
		updateConference() {
			this.user.conference = this.conference;
		},
		loadingBtn(str) {
			var btn = document.getElementById("abstractsSubmitBtn");
			btn.innerHTML = str;
		},
		resetForm() {
			this.user = {
				organization: "",
				first_name: "",
				last_name: "",
				email: "",
				phone_number: "",
				town: "",
				country: "",
				conference: null,
				is_presenter: true,
			};
			this.file = {};
			this.selectedFeeId = null;
		},
		makePayload() {
			let fd = new FormData();
			fd.append("data", JSON.stringify(this.user));
			fd.append("files.abstract_file", this.file);
			return fd;
		},
		handleFile(e) {
			this.file = e.target.files[0];
		},
		handleFee(e) {
			const selected = this.fees.find((f) => String(f.id) === String(e.target.value));
			if (selected) {
				this.selectedFeeId = e.target.value;
				this.user.charges = selected.amount;
			}
		},
		sendEmail(data) {
			// Notify HuQAS staff
			Api.sendemail
				.post({ ...data, template: "conference" })
				.then(() => {
					// Send abstract submission confirmation to the participant
					Api.sendemail
						.post({ ...data, template: "abstractConfirmation" })
						.catch((err) => console.error("[Abstract confirmation error]", err.response?.data || err.message));
				})
				.catch((err) => console.error("[Abstract staff email error]", err.response?.data || err.message));
		},
		handleForm(e) {
			e.preventDefault();
			this.updateConference();
			this.loadingBtn(
				"Sending... <i class='fas fa-circle-notch fa-spin'></i>"
			);
			if (this.validateForm()) {
				Api.conferenceRegistration
					.upload(this.makePayload())
					.then((res) => {
						this.formSent = true;
						this.loadingBtn("Sent! <i class='fas fa-check'></i>");
						// Build file URL and fee data BEFORE resetForm clears state
						const fileData = res.data.abstract_file && res.data.abstract_file[0];
						const selectedFee = this.fees.find(
							(f) => String(f.id) === String(this.selectedFeeId)
						);
						posthog.identify(this.user.email, {
							name: `${this.user.first_name} ${this.user.last_name}`,
							organization: this.user.organization,
							country: this.user.country,
						});
						posthog.capture("conference_abstract_submitted", {
							conference_id: this.user.conference,
							country: this.user.country,
							fee_amount: selectedFee ? selectedFee.amount : this.user.charges,
							fee_currency: selectedFee ? selectedFee.currency : "",
						});
						this.sendEmail({
							...res.data,
							file_name: fileData ? fileData.name : "",
							file_url: fileData ? fileUrl(fileData) : "",
							fee_name: selectedFee ? selectedFee.name : "",
							fee_amount: selectedFee ? selectedFee.amount : res.data.charges,
							fee_currency: selectedFee ? (selectedFee.currency || "KES") : "",
						});
						setTimeout(() => {
							this.formSent = false;
							this.resetForm();
							this.closeModal();
						}, 3000);
					})
					.catch((error) => {
						console.log(typeof error);
						this.loadingBtn(
							`${error.message} <i class='fas fa-exclamation-triangle'></i>`
						);
					});
			}
		},
	},
};
</script>
